// One literal import per package so rspack emits a lazy chunk for each and
// none of them lands in the container's first load on its own. Must list
// exactly the @inno-ui dependencies in package.json minus
// INNO_UI_SHARE_EXCLUDED; federation.innoUiShares.test.ts names what to add
// or remove. See docs/inno-ui-shared-anchor.md.
export const innoUiLoaders: Record<string, () => Promise<unknown>> = {
  '@inno-ui/accordion': () => import('@inno-ui/accordion'),
  '@inno-ui/autocomplete': () => import('@inno-ui/autocomplete'),
  '@inno-ui/avatar': () => import('@inno-ui/avatar'),
  '@inno-ui/avatar-group': () => import('@inno-ui/avatar-group'),
  '@inno-ui/badge-tile': () => import('@inno-ui/badge-tile'),
  '@inno-ui/base-input': () => import('@inno-ui/base-input'),
  '@inno-ui/breadcrumbs': () => import('@inno-ui/breadcrumbs'),
  '@inno-ui/button': () => import('@inno-ui/button'),
  '@inno-ui/charts': () => import('@inno-ui/charts'),
  '@inno-ui/check-list': () => import('@inno-ui/check-list'),
  '@inno-ui/checkbox': () => import('@inno-ui/checkbox'),
  '@inno-ui/chip': () => import('@inno-ui/chip'),
  '@inno-ui/color-picker': () => import('@inno-ui/color-picker'),
  '@inno-ui/communication': () => import('@inno-ui/communication'),
  '@inno-ui/communication-bubble': () =>
    import('@inno-ui/communication-bubble'),
  '@inno-ui/context-menu': () => import('@inno-ui/context-menu'),
  '@inno-ui/counter': () => import('@inno-ui/counter'),
  '@inno-ui/dashboard-widget': () => import('@inno-ui/dashboard-widget'),
  '@inno-ui/date-picker': () => import('@inno-ui/date-picker'),
  '@inno-ui/dialog': () => import('@inno-ui/dialog'),
  '@inno-ui/dropdown': () => import('@inno-ui/dropdown'),
  '@inno-ui/dropzone': () => import('@inno-ui/dropzone'),
  '@inno-ui/empty-state': () => import('@inno-ui/empty-state'),
  '@inno-ui/event-chip': () => import('@inno-ui/event-chip'),
  '@inno-ui/expandable-sidebar': () => import('@inno-ui/expandable-sidebar'),
  '@inno-ui/file-input': () => import('@inno-ui/file-input'),
  '@inno-ui/filter-bar': () => import('@inno-ui/filter-bar'),
  '@inno-ui/filters': () => import('@inno-ui/filters'),
  '@inno-ui/handle': () => import('@inno-ui/handle'),
  '@inno-ui/hint': () => import('@inno-ui/hint'),
  '@inno-ui/kanban': () => import('@inno-ui/kanban'),
  '@inno-ui/label': () => import('@inno-ui/label'),
  '@inno-ui/modal': () => import('@inno-ui/modal'),
  '@inno-ui/node-card': () => import('@inno-ui/node-card'),
  '@inno-ui/number-input': () => import('@inno-ui/number-input'),
  '@inno-ui/onboarding-tour': () => import('@inno-ui/onboarding-tour'),
  '@inno-ui/option-button': () => import('@inno-ui/option-button'),
  '@inno-ui/page-header': () => import('@inno-ui/page-header'),
  '@inno-ui/pagination': () => import('@inno-ui/pagination'),
  '@inno-ui/participants-modal': () => import('@inno-ui/participants-modal'),
  '@inno-ui/password-input': () => import('@inno-ui/password-input'),
  '@inno-ui/phone-input': () => import('@inno-ui/phone-input'),
  '@inno-ui/popover': () => import('@inno-ui/popover'),
  '@inno-ui/progress-bar': () => import('@inno-ui/progress-bar'),
  '@inno-ui/quick-filter-chips': () => import('@inno-ui/quick-filter-chips'),
  '@inno-ui/radio': () => import('@inno-ui/radio'),
  '@inno-ui/radio-list': () => import('@inno-ui/radio-list'),
  '@inno-ui/rating': () => import('@inno-ui/rating'),
  '@inno-ui/results-vs-range': () => import('@inno-ui/results-vs-range'),
  '@inno-ui/sidebar': () => import('@inno-ui/sidebar'),
  '@inno-ui/skeleton': () => import('@inno-ui/skeleton'),
  '@inno-ui/slider': () => import('@inno-ui/slider'),
  '@inno-ui/sparkline': () => import('@inno-ui/sparkline'),
  '@inno-ui/spinner': () => import('@inno-ui/spinner'),
  '@inno-ui/status-chip': () => import('@inno-ui/status-chip'),
  '@inno-ui/stepper': () => import('@inno-ui/stepper'),
  '@inno-ui/styles': () => import('@inno-ui/styles'),
  '@inno-ui/tab-items': () => import('@inno-ui/tab-items'),
  '@inno-ui/tabbed-autocomplete-selector': () =>
    import('@inno-ui/tabbed-autocomplete-selector'),
  '@inno-ui/table': () => import('@inno-ui/table'),
  '@inno-ui/text-input': () => import('@inno-ui/text-input'),
  '@inno-ui/textarea': () => import('@inno-ui/textarea'),
  '@inno-ui/tile-view': () => import('@inno-ui/tile-view'),
  '@inno-ui/time-picker': () => import('@inno-ui/time-picker'),
  '@inno-ui/time-select': () => import('@inno-ui/time-select'),
  '@inno-ui/title': () => import('@inno-ui/title'),
  '@inno-ui/toast': () => import('@inno-ui/toast'),
  '@inno-ui/toggle': () => import('@inno-ui/toggle'),
  '@inno-ui/toggle-button-group': () => import('@inno-ui/toggle-button-group'),
  '@inno-ui/tooltip': () => import('@inno-ui/tooltip'),
  '@inno-ui/tree-select': () => import('@inno-ui/tree-select'),
  '@inno-ui/validator': () => import('@inno-ui/validator'),
  '@inno-ui/z-index': () => import('@inno-ui/z-index'),
  '@inno-ui/zoom-controls': () => import('@inno-ui/zoom-controls')
}
